"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertResponseError = assertResponseError;
var _peperrors = require("@cian/peperrors");
function assertResponseError(response) {
  if (response.statusCode === 200) {
    return;
  }
  const {
    message,
    errors
  } = response.response;
  throw new _peperrors.HttpBadStatusCodeError({
    statusCode: response.statusCode,
    domain: 'src/shared/services/consultingRequest/createConsultingRequest.ts#assertResponseError()',
    message: 'Failed creating consulting request',
    details: {
      message,
      errors
    }
  });
}